"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processedUrl = void 0;
/**
 * @file Manipulate images using Vivaldi backend.
 */
const url_builder_1 = require("./url_builder");
const webp = __importStar(require("./webp"));
const processedUrl = function (url) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!url) {
    console.info('[vivaldi-client] url is null/undefined');
    url = '';
  }
  const processingOptions = [];
  // please keep these alphabetical. Yes, we can sort them using the sort function,
  // but it is also easier to follow for the devs.
  // alignment/rotation
  if (options.align) {
    processingOptions.push(['a', options.align]);
  }
  // aspect ratio
  if (options.ar) {
    processingOptions.push(['ar', options.ar]);
  }
  // crop
  if (options.width || options.height) {
    if (options.crop) processingOptions.push(['c', options.crop]);
    // dpr
    if (options.dpr) processingOptions.push(['dpr', options.dpr]);
  }
  // effects
  if (options.effect) {
    processingOptions.push(['e', options.effect]);
  } else if (options.trim) {
    processingOptions.push(['e', 'trim']);
  }
  // gravity
  if (options.gravity) {
    processingOptions.push(['g', options.gravity]);
  }
  // height
  if (options.height) {
    const intHeight = Math.ceil(options.height);
    processingOptions.push(['h', intHeight]);
  }
  // quality
  if (options.quality) {
    processingOptions.push(['q', options.quality]);
  }
  // width
  if (options.width) {
    const intWidth = Math.ceil(options.width);
    processingOptions.push(['w', intWidth]);
  }
  // format
  let format = null;
  if (options.format) {
    format = options.format;
  } else if (webp.isSupported()) {
    format = 'webp';
  }
  const urlOptions = {
    transforms: processingOptions,
    metadata: !!options.metadata
  };
  if (format) {
    urlOptions.format = format;
  }
  return url_builder_1.buildTransformUrl(url, urlOptions);
};
exports.processedUrl = processedUrl;